<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <!-- <keep-alive> -->
      <router-view></router-view>
      <!-- </keep-alive> -->
    </transition>
  </div>
</template>

<script>

export default {
  name: 'app',
  data(){
    return {
      appVersion: localStorage.getItem('LH_VERSION')
    }
  },
  components: {},
  methods:{

  },
  mounted(){

    console.log('appVersion:', this.appVersion)
    console.log('static version:', this.version)
    if (this.appVersion === null) {
      localStorage.setItem('LH_VERSION', this.version)
      location.reload()
    } else {
      if (this.appVersion !== this.version) {
        localStorage.setItem('LH_VERSION', this.version)
        this.appVersion = this.version
        console.log('url reload')
        window.location.reload()
      }
    }



    // window.location.reload()
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}

</style>
